// Shared by world.ts and levels.ts
import type { Static } from '../../core/types';
import { DEG } from '../../core/draw-helpers';

export const K = 'upsidedown';

/**
 * Place a ball (or part) UNDER a shelf s (for levels where things fall up): lx from the centre along the shelf,
 * r = radius, extra is merged in. Mirror of core `on` (src/core/level-helpers.ts); kept local because only
 * this world has upward gravity.
 */
export function under<E extends object>(s: Pick<Static, 'x' | 'y' | 'h' | 'a'>, lx: number, r: number, extra?: E): { x: number; y: number; r: number } & E {
  const a = (s.a || 0) * DEG;
  const x = s.x + lx * Math.cos(a), y = s.y + lx * Math.sin(a) + (s.h / 2 + r + 1) / Math.cos(a);
  return Object.assign({ x: Math.round(x), y: Math.round(y), r }, extra || ({} as E));
}
